module.exports = __webpack_public_path__ + "img/micromall_doubleWheel.77f11ed6.png";